const headerNav = document.getElementById('site-header');

if (headerNav) {
	window.addEventListener('scroll', () => {
		if (window.scrollY == 0) {
			headerNav.classList.add('at-top');
		} else {
			headerNav.classList.remove('at-top');
		}

		if (window.scrollY > 132) {
			headerNav.classList.add('is-sticky');
		} else if (window.scrollY < 132) {
			headerNav.classList.remove('is-sticky');
		}
	});
}

document.addEventListener('DOMContentLoaded', () => {
	const sidebar = document.querySelector('.sidebar');
	const adminBar = document.querySelector('body').classList.contains('admin-bar') ? true : false;
	const section = document.querySelector('.single-location-content');
	const headerHeight = adminBar ? 150 : 118;
	const breakpoint = 1023;

	if (sidebar && section) {
		const updateSidebarPosition = () => {
			const windowWidth = window.innerWidth;
			if (windowWidth <= breakpoint) {
				sidebar.classList.remove('is-sticky', 'at-bottom');
				sidebar.style.top = '';
				return;
			}

			const sectionRect = section.getBoundingClientRect();
			const sidebarHeight = sidebar.offsetHeight;

			if (sectionRect.top <= headerHeight && sectionRect.bottom >= sidebarHeight + headerHeight) {
				sidebar.classList.add('is-sticky');
				sidebar.classList.remove('at-bottom');
				sidebar.style.top = `${headerHeight}px`;
			} else if (sectionRect.bottom < sidebarHeight + headerHeight) {
				sidebar.classList.add('at-bottom');
				sidebar.classList.remove('is-sticky');
				sidebar.style.top = '';
			} else {
				sidebar.classList.remove('is-sticky', 'at-bottom');
				sidebar.style.top = '';
			}
		};

		// Run on scroll and resize
		window.addEventListener('scroll', updateSidebarPosition);
		window.addEventListener('resize', updateSidebarPosition);

		// Initial check
		updateSidebarPosition();
	}
});
